import guest from "@/middleware/guest";

export default [
  {
      path: "",
      component: () => import("@/modules/layout/LandingLayout"),
      children: [
          {
              path: "/acesso/:mailing",
              name: "landing",
              meta: { middleware: [guest] },
              component: () => import("./Landing"),
          },
      ]
  },
];
